// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AsapNotificationsController from "./asap_notifications_controller"
application.register("asap-notifications", AsapNotificationsController)

import BackController from "./back_controller"
application.register("back", BackController)

import BookingFormController from "./booking_form_controller"
application.register("booking-form", BookingFormController)

import BookingWizardSelectionsController from "./booking_wizard_selections_controller"
application.register("booking-wizard-selections", BookingWizardSelectionsController)

import Bridge__AppVersionController from "./bridge/app_version_controller"
application.register("bridge--app-version", Bridge__AppVersionController)

import Bridge__AuthenticationTokenBaseController from "./bridge/authentication_token_base_controller"
application.register("bridge--authentication-token-base", Bridge__AuthenticationTokenBaseController)

import Bridge__AuthenticationTokenController from "./bridge/authentication_token_controller"
application.register("bridge--authentication-token", Bridge__AuthenticationTokenController)

import Bridge__DownloadFileController from "./bridge/download_file_controller"
application.register("bridge--download-file", Bridge__DownloadFileController)

import Bridge__LoginController from "./bridge/login_controller"
application.register("bridge--login", Bridge__LoginController)

import Bridge__PickTenantController from "./bridge/pick_tenant_controller"
application.register("bridge--pick-tenant", Bridge__PickTenantController)

import Bridge__RecentlyVisitedTenantsController from "./bridge/recently_visited_tenants_controller"
application.register("bridge--recently-visited-tenants", Bridge__RecentlyVisitedTenantsController)

import Bridge__RegisterPushNotificationsController from "./bridge/register_push_notifications_controller"
application.register("bridge--register-push-notifications", Bridge__RegisterPushNotificationsController)

import Bridge__SwitchTenantController from "./bridge/switch_tenant_controller"
application.register("bridge--switch-tenant", Bridge__SwitchTenantController)

import ButtonStatusController from "./button_status_controller"
application.register("button-status", ButtonStatusController)

import CameraControlsController from "./camera_controls_controller"
application.register("camera-controls", CameraControlsController)

import ChangeEncryptionPasswordController from "./change_encryption_password_controller"
application.register("change-encryption-password", ChangeEncryptionPasswordController)

import ChangePasswordController from "./change_password_controller"
application.register("change-password", ChangePasswordController)

import ChatFileDetailsController from "./chat_file_details_controller"
application.register("chat-file-details", ChatFileDetailsController)

import CheckableLinkController from "./checkable_link_controller"
application.register("checkable-link", CheckableLinkController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CreateProxyEntitlementController from "./create_proxy_entitlement_controller"
application.register("create-proxy-entitlement", CreateProxyEntitlementController)

import DocumentUpload__ErrorMessageController from "./document_upload/error_message_controller"
application.register("document-upload--error-message", DocumentUpload__ErrorMessageController)

import DocumentUpload__ProgressBarController from "./document_upload/progress_bar_controller"
application.register("document-upload--progress-bar", DocumentUpload__ProgressBarController)

import DownloadFileController from "./download_file_controller"
application.register("download-file", DownloadFileController)

import EmpScannerController from "./emp_scanner_controller"
application.register("emp-scanner", EmpScannerController)

import EncounterController from "./encounter_controller"
application.register("encounter", EncounterController)

import EncryptionController from "./encryption_controller"
application.register("encryption", EncryptionController)

import EncryptionPasswordController from "./encryption_password_controller"
application.register("encryption-password", EncryptionPasswordController)

import EncryptionStatusController from "./encryption_status_controller"
application.register("encryption-status", EncryptionStatusController)

import EncryptionUnlockingController from "./encryption_unlocking_controller"
application.register("encryption-unlocking", EncryptionUnlockingController)

import ExemptPageFromCacheController from "./exempt_page_from_cache_controller"
application.register("exempt-page-from-cache", ExemptPageFromCacheController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import FileDetailsController from "./file_details_controller"
application.register("file-details", FileDetailsController)

import FileFormController from "./file_form_controller"
application.register("file-form", FileFormController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GenerateProxyTokenModalController from "./generate_proxy_token_modal_controller"
application.register("generate-proxy-token-modal", GenerateProxyTokenModalController)

import InputPatternValidatorController from "./input_pattern_validator_controller"
application.register("input-pattern-validator", InputPatternValidatorController)

import LocaleController from "./locale_controller"
application.register("locale", LocaleController)

import LoginController from "./login_controller"
application.register("login", LoginController)

import MedicationPlan__AccordionToggleController from "./medication_plan/accordion_toggle_controller"
application.register("medication-plan--accordion-toggle", MedicationPlan__AccordionToggleController)

import MedicationPlan__LoaderController from "./medication_plan/loader_controller"
application.register("medication-plan--loader", MedicationPlan__LoaderController)

import MedicationPlan__ShowController from "./medication_plan/show_controller"
application.register("medication-plan--show", MedicationPlan__ShowController)

import MessageController from "./message_controller"
application.register("message", MessageController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PasswordHashingController from "./password_hashing_controller"
application.register("password-hashing", PasswordHashingController)

import PasswordInputController from "./password_input_controller"
application.register("password-input", PasswordInputController)

import PasswordValidationController from "./password_validation_controller"
application.register("password-validation", PasswordValidationController)

import PatientFormController from "./patient_form_controller"
application.register("patient-form", PatientFormController)

import PatientInvitationsController from "./patient_invitations_controller"
application.register("patient-invitations", PatientInvitationsController)

import PrepareEncryptionController from "./prepare_encryption_controller"
application.register("prepare-encryption", PrepareEncryptionController)

import ProxyManagementController from "./proxy_management_controller"
application.register("proxy-management", ProxyManagementController)

import ProxySessionController from "./proxy_session_controller"
application.register("proxy-session", ProxySessionController)

import RecoveryTokenController from "./recovery_token_controller"
application.register("recovery-token", RecoveryTokenController)

import ResetAccountEncryptionController from "./reset_account_encryption_controller"
application.register("reset-account-encryption", ResetAccountEncryptionController)

import ResetEncryptionPasswordController from "./reset_encryption_password_controller"
application.register("reset-encryption-password", ResetEncryptionPasswordController)

import ResetPasswordController from "./reset_password_controller"
application.register("reset-password", ResetPasswordController)

import ScrollerController from "./scroller_controller"
application.register("scroller", ScrollerController)

import SearchTenantsController from "./search_tenants_controller"
application.register("search-tenants", SearchTenantsController)

import SelectPlaceholderColorController from "./select_placeholder_color_controller"
application.register("select-placeholder-color", SelectPlaceholderColorController)

import ShareFileController from "./share_file_controller"
application.register("share-file", ShareFileController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)
